import React from 'react';
import { styled } from '@mui/material/styles';
import { Tooltip, TooltipProps, tooltipClasses, Box } from '@mui/material';

// Styled component for the tooltip
const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#210158', // Custom background color
    color: 'white', // Custom text color
    maxWidth: 250, // Set max width
    fontSize: theme.typography.pxToRem(12), // Use theme typography for font size
    border: '1px solid #35008F', // Optional border
    borderRadius: theme.shape.borderRadius, // Consistent border-radius from theme
    boxShadow: theme.shadows[3], // Use theme shadow for consistency
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#2d2d2d', // Match arrow color with background
  },
}));

// Component
interface CustomTooltipProps extends TooltipProps {
  padding?: string | number
}

export const CustomTooltip: React.FC<CustomTooltipProps> = ({
  title,
  padding = 1, // Default padding
  ...props
}) => (
  <StyledTooltip
    {...props}
    arrow
    title={
      <Box sx={{ p: padding }}>
        {title}
      </Box>
    }
  />
)
